import { InfoIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";
import { Tooltip } from "components";
import { ReactNode } from "react";

interface SectionLabelProps {
  children: ReactNode;
  tooltip?: string;
}

export const SectionLabel = ({ children, tooltip }: SectionLabelProps) => (
  <Flex alignItems="center" gap={2} mb={2}>
    <Text
      textTransform="uppercase"
      fontSize="xs"
      fontWeight="bold"
      letterSpacing="wider"
      color="gray.500"
    >
      {children}
    </Text>
    {tooltip && (
      <Tooltip label={tooltip} shouldWrapChildren>
        <InfoIcon boxSize={3} color="gray.400" />
      </Tooltip>
    )}
  </Flex>
);
